module.exports = __webpack_public_path__ + "static/Singapore_dark-aeb9a5b7a8d0b6c8b0e4c99779596251.svg";